"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripUnit = function (value) {
    if (typeof value !== 'string')
        return [value, undefined];
    var matchedValue = value.match(/^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/);
    if (matchedValue)
        return [parseFloat(value), matchedValue[2]];
    return [parseFloat(value), undefined];
};
//# sourceMappingURL=stripUnit.js.map